import { allEvents } from '@/utils/content';

export interface FilterState {
  event: string;
  dateFrom: string;
  dateTo: string;
  rankFrom: number;
  rankTo: number;
}

interface Props {
  value: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
  resultCount: number;
}

const inputClass =
  'w-full px-3 py-2 text-sm rounded-md bg-background-50 border border-background-300 text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors';
const labelClass = 'block text-xs font-medium text-foreground-600 mb-1.5';

export default function BlacklistFilter({ value, onChange, onReset, resultCount }: Props) {
  const update = (patch: Partial<FilterState>) => onChange({ ...value, ...patch });

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelClass} htmlFor="filter-event">
            赛事名称
          </label>
          <select
            id="filter-event"
            value={value.event}
            onChange={(e) => update({ event: e.target.value })}
            className={`${inputClass} cursor-pointer`}
          >
            <option value="all">全部赛事</option>
            {allEvents.map((event) => (
              <option key={event} value={event}>
                {event}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className={labelClass}>排名区间</label>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={1}
              value={value.rankFrom}
              onChange={(e) => update({ rankFrom: Number(e.target.value) || 1 })}
              className={inputClass}
              placeholder="起始"
              aria-label="起始排名"
            />
            <span className="text-foreground-400">-</span>
            <input
              type="number"
              min={1}
              value={value.rankTo}
              onChange={(e) => update({ rankTo: Number(e.target.value) || 20 })}
              className={inputClass}
              placeholder="结束"
              aria-label="结束排名"
            />
          </div>
        </div>
        <div>
          <label className={labelClass}>开始日期</label>
          <input
            type="date"
            value={value.dateFrom}
            onChange={(e) => update({ dateFrom: e.target.value })}
            className={`${inputClass} cursor-pointer`}
          />
        </div>
        <div>
          <label className={labelClass}>结束日期</label>
          <input
            type="date"
            value={value.dateTo}
            onChange={(e) => update({ dateTo: e.target.value })}
            className={`${inputClass} cursor-pointer`}
          />
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 pt-1 flex-wrap">
        <span className="text-sm text-foreground-500">
          共筛选出 <span className="font-bold text-primary-700">{resultCount}</span> 条黑榜数据
        </span>
        <button
          type="button"
          onClick={onReset}
          className="px-4 py-2 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line align-middle mr-1"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}